var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4989 0.5C15.2194 0.588499 13.7239 1.40749 12.8525 2.47399C12.0575 3.44148 11.4035 4.87847 11.6585 6.27497C13.0565 6.31847 14.5009 5.47997 15.3379 4.39548C16.1209 3.38598 16.7134 1.95799 16.4989 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5554 8.55192C20.3269 7.01143 18.6004 6.11743 16.9699 6.11743C14.8174 6.11743 13.9069 7.14793 12.4114 7.14793C10.8694 7.14793 9.69792 6.12043 7.83643 6.12043C6.00794 6.12043 4.06095 7.23792 2.82646 9.14891C1.09097 11.8399 1.38797 16.8994 4.20045 21.2088C5.20695 22.7508 6.55094 24.4848 8.30893 24.4998C9.87342 24.5148 10.3144 23.4963 12.4339 23.4858C14.5534 23.4738 14.9554 24.5133 16.5169 24.4968C18.2764 24.4833 19.6939 22.5618 20.7004 21.0198C21.4219 19.9144 21.6904 19.3579 22.2498 18.1099C18.1804 16.5604 17.5279 10.7734 21.5554 8.55192Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.2cd2e5b504c841d0d5fe5bf837f46901.svg";
export { ForwardRef as ReactComponent };